/** @file identityLocals: the rest pose's locals: identity keys, document flags, node-clock frame keys. */
import type { Rig } from '@zilo/pose3d-pose/rig/rigTypes';
import type { LocalPose } from '@zilo/pose3d-pose/sample/localTypes';
import { frameAnimKey } from '@zilo/pose3d-pose/time/frameAnimKey';

/**
 * Identity rotation, zero position, scale 1, default parent, `hidden` from the document, the default frame animation at
 * the node's own counter (`frameAnimTicks`, 21.2: the node clock runs without a clip too; absent = tick 0).
 */
export function identityLocals(rig: Rig, out: LocalPose, frameAnimTicks?: Readonly<Record<string, number>>): LocalPose {
  out.forEach((local, i) => {
    local.rot[0] = 0; local.rot[1] = 0; local.rot[2] = 0; local.rot[3] = 1;
    local.pos[0] = 0; local.pos[1] = 0; local.pos[2] = 0;
    local.scale = 1;
    local.parent = -1;
    local.hidden = rig.hiddenDefault[i] === 1;
    local.rotToggle = false;
    const anim = rig.frameAnim[i] ?? null;
    local.frameKey = anim === null ? 0 : frameAnimKey(anim, frameAnimTicks?.[rig.names[i] ?? ''] ?? 0);
  });
  return out;
}
